import React from 'react'
import styled from "styled-components";
import FramePuzzlePrizes from "../../../../../assets/images/Event-2026/FramePuzzlePrizes2.png";
import FrameMission from "../../../../../assets/images/Event-2026/FrameMission2.png";
import Icon from "../../../../../assets/images/Event-2026/icon1.svg";
import IconMinus from "../../../../../assets/images/Event-2026/minus.png";
import IconPlus from "../../../../../assets/images/Event-2026/plus.png";
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNewYear2025Theme } from 'helper/const';

export default function ChangeCoinsByBids({
	bid,
	setBid,
	bidTotal,
	handleTurnMini,
	userInfo,
	showDataLogin,
	handleToBuyTurn,
	isAuthenticated
}) {
	const { t } = useTranslation();

	const handleChangeBid = (type) => {
		if (!userInfo) {
			return showDataLogin();
		}
		if (!bidTotal) {
			return null;
		}
		if (type === "add") {
			return setBid(bid + 1);
		}

		if (bid !== 1) {
			setBid(bid - 1);
		}
	};

	const handleInputBid = (e) => {
		const value = e.target.value;

		if (value === "" || Number(value) < 1) {
			setBid(1);
			return;
		}

		const num = Number(value);

		if (isNaN(num)) return;

		if (num < 1) {
			setBid(1);
			return;
		}

		if (num > 100) {
			setBid(100);
			return;
		}

		setBid(num);
	};
	const isError = isAuthenticated && (bidTotal === 0 || bidTotal < bid)

	return (
		<Container>
			<div className={`frame ${isError && 'frame-Error'}`}>
				<h4 className='title'>{t('change_coins_by_bids')}</h4>
				<div className={`content ${isError && 'content-Error'}`}>
					<div className='content-top'>
						<img src={Icon} alt="icon" />
						<span>{t('change_1_coin_1_bid')}</span>
					</div>
					<div className='content-bottom'>
						<div className='content-bottom_number'>
							<Button onClick={() => handleChangeBid("minus")}><img src={IconMinus} alt="" /></Button>
							<input
								className='btn-total'
								value={bid}
								onChange={handleInputBid}
								type="number"
								inputMode="numeric"
								min={1}
								max={100}
							/>
							<Button onClick={() => handleChangeBid("add")}><img src={IconPlus} alt="" /></Button>
						</div>
						<button
							onClick={handleTurnMini}
							className={`change-now  ${bidTotal === 0 || bidTotal < bid
								? "disable-button-change-turn"
								: "scale-hover-item"
								}`}
						>
							{`${t('change_now')} (${t("mini_game.standard_missions.change_turns")
								.replace("X", bid)
								.replace("turns", +bid > 1 ? "turns" : "turn")})`}
						</button>
					</div>
					{isError ? (
						<ErrorContainer>
							<div className='content-error-mini-change'>
								{bidTotal === 0
									? t("you_have_no_bids_left_to_change")
									: t("the_number_of_coins_must_not_exceed_the_number_of_bids")}
							</div>
						</ErrorContainer>
					) : null}
				</div>
			</div>
		</Container>
	)
}

const ErrorContainer = styled.div`
	background-color: transparent;
	padding: 5px;
	border-radius: 12px;

	.content-error-mini-change,
	.content-error-mini-buy {
		font-size: 14px;

		@media (min-width: 768px) {
			font-size: 14px;
		}
	}
`;

const Container = styled.div`
	.frame{
		background-image: url(${FramePuzzlePrizes});
			background-position: center;
			background-repeat: no-repeat;
			background-size: 100% 100%;
			width: 100%;
			height: 355px;
			position: relative;
			max-width: 1200px;
			margin: auto;
			
			@media (max-width: 768px) {
				height: 255px;
			}
	}

	.frame-Error{
		height: 375px;
			@media (max-width: 768px) {
					height: 345px;
			}
	}

	.content-bottom{
		display: flex;
		gap: 30px;
		padding-top: 22px;
			@media (max-width: 768px) {
					gap: 7px;
			}
		.change-now{
			border: none;
			outline: none;
				background: linear-gradient(
				180deg,
				rgba(217, 96, 20, 1) 0%,
				rgba(254, 145, 4, 1) 100%
			);
			width: 100%;
			border-radius: 12px;
			font-size: 18px;
			font-weight: 600;
				@media (max-width: 768px) {
				font-size: 14px;

			}
		}
		.content-bottom_number{
			background: #fff;
			display: flex;
			justify-content: center;
			align-items: center;
			gap: 5px;
			border-radius: 30px;
			@media (max-width: 768px) {
					height:45px;
					gap: 1px;
			}

			input{
				border: none;
				outline: none;
				color: rgba(22, 36, 129, 1);
				font-size: 30px;
				font-weight: 600;
				width: 120px;
				text-align: center;
				@media (max-width: 768px) {
					width: 50px;
					font-size: 14px;
				}
			}
			button {
				border: 3px solid transparent;
				background:
				linear-gradient(#fff, #fff) padding-box,
				linear-gradient(
					180deg,
					rgba(24, 54, 196, 1) 0%,
					rgba(0, 125, 249, 1) 100%
				) border-box;
				border-radius: 50%;
				height: 60px;
				width: 60px;
				@media (max-width: 768px) {
					height: 45px;
					width: 45px;
				}	
				img{
					width: 30px;
					object-fit: cover;
				}
			}
		}
	}
	.content-top{
		img{
			height: 60px;
			width: 60px;
			object-fit: cover;
			margin-right: 15px;
			@media (max-width: 768px) {
				height: 40px;
				width: 40px;
			}
		}
		span{
			color: rgba(22, 36, 129, 1);
			font-size: 20px;
			font-weight: 700;
			@media (max-width: 768px) {
				font-size: 14px;
			}
		}
	}
	.content{
			background-image: url(${FrameMission});
			background-position: center;
			background-repeat: no-repeat;
			background-size: 100% 100%;
			width: calc(100% - 80px);
			height: 195px;
			flex-shrink: 0;
			position: absolute;
			bottom: -54px;
			left: 50%;
			transform: translate(-50%,-50%);
			padding: 20px;
			@media (max-width: 768px) {
				width: calc(100% - 40px);
				height: 137px;
				bottom: -38px;
				padding: 7px;
			}
	}

	.content-Error{
		height: 204px;

		@media (max-width: 768px) {
					height: 180px;
			}
	}
	.title{
		color: rgba(253, 221, 16, 1);
		font-size: 20px;
		font-weight: 800;
		text-transform: uppercase;
		position: absolute;
		top: 43px;
    left: 4.5%;

		@media (max-width: 768px) {
			top: 13%;
			left: 5%;
			font-size: 14px;
			max-width: 250px;
		}
		@media (min-width: 768px) and (max-width: 1024px) {
				font-size: 14px;
			}

			@media (min-width: 834px) and (max-width: 1194px) {
						font-size: 16px;
			}

			@media (min-width: 1024px) and (max-width: 1366px) {
						font-size: 18px;
			}
	}

`